import { db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

export default {
  name: "ProfileDashboardLogic",
  data() {
    return {
      userProfile: null,
      loadingProfile: false,
      profileError: null
    };
  },
  async created() {
    await this.fetchUserProfile();
  },
  methods: {
    async fetchUserProfile() {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        this.profileError = "User not logged in.";
        return;
      }
      this.loadingProfile = true;
      try {
        const userID = user.uid;
        const userRef = doc(db, "users", userID);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          this.userProfile = userSnap.data();
          console.log("Fetched user profile:", this.userProfile);
        } else {
          this.profileError = "User profile not found.";
        }
      } catch (err) {
        console.error("Error fetching user profile:", err);
        this.profileError = "Error fetching user profile.";
      } finally {
        this.loadingProfile = false;
      }
    }    
  }
};
